import React from 'react'
import FormulaButton from '../formulaButton'
import PropertyButton from './propertyButton'
import PropTypes from 'prop-types'
import PropertyTableForm from '../forms/propertyTableForm'
import { Label, Input, InputGroup, FormText, DropdownToggle, InputGroupButtonDropdown, DropdownItem, DropdownMenu } from 'reactstrap'
import { H2SO4Density, P2O5Density, ebullitionChartProperties, physicalProperties, H2SiF6Density } from '../../../formulas/propertyTables'
import { FaArrowLeft } from 'react-icons/fa'

export default class PropertyCalculationButton extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedForm: false,
            dropdownOpen: false
        }
    }

    tableSelected = (e, name) => {
        e.preventDefault()
        e.stopPropagation()
        this.setState({ selectedForm: name })
        this.props.clearValues()
        this.props.valueToState({type: 'PRESSURE'}) 
    }

    toggleDropDown = (e) => {
        e.preventDefault()
        e.stopPropagation()
        this.setState({ dropDownOpen: !this.state.dropDownOpen })
    }

    densityTempInput = () => {
        return (
            <React.Fragment>
                <InputGroup>
                    <div className="col-md-6">
                        <Label for="temperature">Temperature <b>(°C)</b></Label>
                    </div>
                    <div className="col-md-6">
                        <Input value={this.props.values.temperature} required type="number" name="temperature" id="temperature" onChange={this.handleChange} />
                    </div>
                </InputGroup>
                <br />
                <InputGroup>
                    <div className="col-md-6">
                        <Label for="density">Density <b>(kg/L)</b></Label>
                    </div>
                    <div className="col-md-6">
                        <Input step={0.00001} value={this.props.values.density} required type="number" name="density" id="density" onChange={this.handleChange} />
                    </div>
                </InputGroup>
                <br />
            </React.Fragment>
        )
    }

    valInput = () => {
        return (
            <div className="physical-property-form">
                <InputGroup>
                    <div className="col-md-2">
                        <Label for="val">Value</Label>
                    </div>
                    <div className="col-md-10">
                        <InputGroup>
                            <Input step={0.0001} value={this.props.values.val} required type="number" name="val" id="val" onChange={this.handleChange} />
                            <InputGroupButtonDropdown addonType="append" isOpen={this.state.dropDownOpen} toggle={this.toggleDropDown}>
                                <DropdownToggle caret>
                                    {this.props.values.type === 'PRESSURE' ? 'Pressure (bar)' : 'Temperature (°C)'}
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem onClick={() => this.props.valueToState({ "type": 'PRESSURE' })} >Pressure (bar)</DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem onClick={() => this.props.valueToState({ "type": 'TEMPERATURE' })}>Temperature (°C)</DropdownItem>
                                </DropdownMenu>
                            </InputGroupButtonDropdown>
                        </InputGroup>
                    </div>
                </InputGroup>
                <br />
            </div>
        )
    }

    tempPercentInput = () => {
        return (
            <React.Fragment>
                <InputGroup>
                    <div className="col-md-6">
                        <Label for="temperature">Temperature <b>(°C)</b></Label>
                    </div>
                    <div className="col-md-6">
                        <Input value={this.props.values.temperature} required type="number" name="temperature" id="temperature" onChange={this.handleChange} />
                    </div>
                </InputGroup>
                <br />
                <InputGroup>
                    <div className="col-md-6">
                        <Label for="percent">Desired P2O5 <b>(%)</b></Label>
                    </div>
                    <div className="col-md-6">
                        <Input value={this.props.values.percent} required type="number" name="percent" id="percent" onChange={this.handleChange} />
                    </div>
                </InputGroup>
                <br />
            </React.Fragment>
        )
    }

    getForm = () => {
        switch (this.state.selectedForm) {
            case 'P2O5':
                return (
                    <PropertyTableForm type="P2O5" {...this.props} btnName="Calculate P2O5 %" calcFormula={P2O5Density}>
                        <h5 className="text-center property-form-title">P2O5 Concentration</h5>
                        <br />
                        {this.densityTempInput()}
                    </PropertyTableForm>
                )
            case 'H2SO4_PROPERTY':
                return (
                    <PropertyTableForm type="H2SO4_PROPERTY" {...this.props} btnName="Calculate H2SO4 %" calcFormula={H2SO4Density}>
                        <h5 className="text-center property-form-title">H2SO4 Concentration</h5>
                        <br />
                        {this.densityTempInput()}
                    </PropertyTableForm>
                )
            case 'PHYSICAL_PROPERTY':
                return (
                    <PropertyTableForm type="PHYSICAL_PROPERTY"  {...this.props} btnName="Calculate saturated steam" calcFormula={physicalProperties}>
                        <h5 className="text-center property-form-title">Saturated Steam Properties</h5>
                        <br />
                        {this.valInput()}
                    </PropertyTableForm>
                )
            case 'EBULLITION':
                return (
                    <PropertyTableForm type="EBULLITION" {...this.props} btnName="Calculate absolute pressure (mbars)" calcFormula={ebullitionChartProperties}>
                        <h5 className="text-center property-form-title">Concentrated acid's ebullition pressure</h5>
                        <br />
                        {this.tempPercentInput()}
                    </PropertyTableForm>
                )
            case 'H2SiF6':
                return (
                    <PropertyTableForm type="H2SiF6" {...this.props} btnName="Calculate H2SiF6 %" calcFormula={H2SiF6Density}>
                        <h5 className="text-center property-form-title">H2SiF6 Concentration</h5>
                        <br />
                        {this.densityTempInput()}
                    </PropertyTableForm>
                )
            default:
                break
        }
    }

    handleChange = (e) => {
        const target = e.target
        this.props.valueToState({ [target.name]: target.value }) // Redux
    }

    render() {
        console.log(this.props)
        return (
            <div>
                <FormulaButton label="Property Tables" iconName="propertyTable">
                    {this.state.selectedForm ?
                        <React.Fragment>
                            <div className="back-button" onClick={(e) => this.tableSelected(e, false)}>
                                <FaArrowLeft />
                                <p> Back to menu</p>
                            </div>
                            {this.getForm()}
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <div className="text-center">
                                <h4 >Property Tables menu</h4>
                                <p >Choose a property table</p>
                            </div>
                            <ul>
                                <li onClick={(e) => this.tableSelected(e, 'P2O5')}>
                                    <PropertyButton label="P2O5 Concentration" />
                                </li>
                                <li onClick={(e) => this.tableSelected(e, 'H2SO4_PROPERTY')}>
                                    <PropertyButton label="H2SO4 Concentration" />
                                </li>
                                <li onClick={(e) => this.tableSelected(e, 'PHYSICAL_PROPERTY')}>
                                    <PropertyButton label="Calculate Saturated Steam Properties" />
                                </li>
                                <li onClick={(e) => this.tableSelected(e, 'EBULLITION')}>
                                    <PropertyButton label="Concentrated acid's ebullition pressure" />
                                </li>
                                <li onClick={(e) => this.tableSelected(e, 'H2SiF6')}>
                                    <PropertyButton label="H2SiF6 Concentration" />
                                </li>
                            </ul>
                            <FormText>
                                All properties calculated are indicative and based on reference tables available in the « documents » block.
                            </FormText>
                        </React.Fragment>
                    }
                </FormulaButton>
            </div>
        )
    }
}
PropertyCalculationButton.propTypes = {
    values: PropTypes.object,
    valueToState: PropTypes.func,
    clearValues: PropTypes.func,
}